// Copyright (c) 2017 Deere & Company

import KeyValuePair from './key-value-pair';
import t from 'tcomb';

const ReimbursementDetails = t.struct({
    approvedAmount: t.maybe(t.Number),
    currency: t.maybe(KeyValuePair),
    reimbursementPercentage: t.maybe(t.Number),
    requestedAmount: t.maybe(t.Number),
    withAdditives: t.maybe(t.Number)
}, {
    name: 'ReimbursementDetails',
    strict: true
});

export const getDefaultState = () => new ReimbursementDetails({
    approvedAmount: 0,
    reimbursementPercentage: 0,
    requestedAmount: 0,
    withAdditives: 0
});

export default ReimbursementDetails;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/reimbursement-details.js